import './faq.scss';

class Accordion {
    constructor ($element) {
        this.$accordion = $element;
        this.$$accordionToggle = this.$accordion.querySelectorAll('[data-accordion="areaToggle"]');
        this.initialize();
    }

    initialize () {
        this.changeA11yLabelsByCheckbox();
    }

    // Set Aria Labels for Accordion by Checkbox / On click
    changeA11yLabelsByCheckbox () {
        if (this.$$accordionToggle.length > 0) {
            this.$$accordionToggle.forEach($areaToggle => {
                let areaActive = ($areaToggle.dataset.accordionActive === 'true');
                console.log(areaActive);
                const $areaContent = $areaToggle.parentElement.parentElement.querySelector('[data-accordion="areaContent"]');

                const checkAreaState = () => {
                    if (areaActive) {
                        $areaToggle.setAttribute('aria-selected', 'true');
                        $areaContent.setAttribute('aria-hidden', 'false');
                    } else {
                        $areaToggle.setAttribute('aria-selected', 'false');
                        $areaContent.setAttribute('aria-hidden', 'true');
                    }
                };

                // Init call - set Aria Labels by Aria State
                checkAreaState();

                $areaToggle.onclick = () => {
                    areaActive = !areaActive;
                    $areaToggle.dataset.accordionActive = areaActive;
                    checkAreaState();
                };
            });
        }
    }
}

export { Accordion };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$accordion = $context.querySelectorAll('[data-accordion="root"]');
        for (let i = 0; i < $$accordion.length; i++) {
            const $accordion = $$accordion[i];

            $accordion.API = new Accordion($accordion);
        }
    }
});
